// ENERGY v2 — the energy desk's own figures, as a sheet (?desk=1) (UI rebuild batch 4, adopted by the energy lane).
// Astra: "show provider balance as context" and hide "funding instructions". The list keeps the TronSave balance in its box; this
// sheet holds the rest of Energy.tsx's tiles and its "About this screen": where to send TRX, the limits, what one transfer costs now,
// the energy rented, the provider — ONE FACT A LINE (his words, 1 Nov 2026: "check everything where it applies"), each figure with
// its unit after it. ONE COPY: the figures (deskFigures) and every sentence of the About (AboutEnergy) are screens/Energy.tsx's,
// folded here.
import type { EnergyStatus } from '../../../lib/api';
import { reasonLead } from '../../../lib/energyOrder';
import { DetailSheet, Fact } from '../kit';
import { CopyRef } from '../../CopyRef';
import { EnergyFigure, TrxFigure } from './parts';
import { AboutEnergy, deskFigures, mask, trx } from '../../../screens/Energy';

export function DeskSheet({ d, onClose }: { d: EnergyStatus; onClose: () => void }) {
  const { oneTransfer, noPrice, rentedNow, oneTransferLabel } = deskFigures(d);
  return (
    <DetailSheet title="Energy desk" onClose={onClose}>
      <div>
        <Fact label={d.provider.error !== null ? 'Balance · last known' : 'TronSave balance'}>
          <TrxFigure value={trx(d.provider.balanceSun)} />
        </Fact>
        {d.provider.depositAddress && <Fact label="Send TRX to"><CopyRef value={d.provider.depositAddress} label={mask(d.provider.depositAddress)} /></Fact>}
        <Fact label="Spent in 24h"><TrxFigure value={trx(d.spend.countedSun)} /></Fact>
        <Fact label="Limit in 24h"><TrxFigure value={trx(d.spend.dailyCapSun)} /></Fact>
        <Fact label="Order limit"><TrxFigure value={trx(d.spend.orderCapSun)} /></Fact>
        <Fact label={oneTransferLabel}>
          {oneTransfer ? <TrxFigure value={trx(oneTransfer.costSun)} /> : noPrice ? reasonLead(noPrice).lead : <span className="text-tg-hint">—</span>}
        </Fact>
        <Fact label="Energy rented"><EnergyFigure n={String(rentedNow)} /></Fact>
        <Fact label="Provider">{d.provider.name}</Fact>
      </div>

      <details className="mt-5 border-t border-stroke-soft pt-4 text-meta text-tg-hint">
        <summary className="tap-44 cursor-pointer">About energy</summary>
        <div className="mt-2 space-y-2">
          <AboutEnergy d={d} rentalsHere={false} />
        </div>
      </details>
    </DetailSheet>
  );
}
